import {
  ChangeDetectionStrategy,
  Component,
  ElementRef,
  HostListener,
  computed,
  inject,
  signal,
} from '@angular/core';
import {
  NotificationSettingsService,
  NotificationStore,
} from '@cardapio-online/notifications';

@Component({
  selector: 'lib-ui-notification-bell',
  templateUrl: './ui-notification-bell.component.html',
  styleUrl: './ui-notification-bell.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class UiNotificationBellComponent {
  private readonly hostElement = inject(ElementRef<HTMLElement>);

  protected readonly notificationStore = inject(NotificationStore);
  protected readonly notificationSettingsService = inject(
    NotificationSettingsService
  );
  protected readonly notificationSettings =
    this.notificationSettingsService.settings;
  protected readonly isOpen = signal(false);
  protected readonly unreadCount = computed(() =>
    this.notificationSettings().showUnreadBadge
      ? this.notificationStore.unreadCount()
      : 0
  );
  protected readonly panelNotifications = computed(() =>
    this.notificationStore.latest(6)
  );
  protected readonly hasNotifications = computed(
    () => this.notificationStore.events().length > 0
  );

  protected togglePanel(): void {
    this.isOpen.update((current) => !current);
  }

  protected closePanel(): void {
    this.isOpen.set(false);
  }

  protected clearNotifications(): void {
    this.notificationStore.clear();
  }

  @HostListener('document:click', ['$event'])
  protected onDocumentClick(event: MouseEvent): void {
    if (!this.isOpen()) {
      return;
    }

    const target = event.target as Node | null;

    if (target && this.hostElement.nativeElement.contains(target)) {
      return;
    }

    this.closePanel();
  }
}
